<svelte:options tag="roll-over" />

<div id="hover-wrapper">
  <div id="hover-body" class:light-theme={lighttheme}>
    <slot />
  </div>
</div>

<script>
  export let lighttheme
  $: lighttheme = lighttheme || lighttheme === ''
</script>

<style type="text/scss">
  :host {
    display: none;
  }

  #hover-body {
    position: relative;
    background-color: var(--ripe-app-navbar-background, #080037);
    z-index: 999999;
    min-width: 312px;
    margin-top: 30px;
    color: white;
    padding: 0;
  }

  ::slotted(p),
  ::slotted(h4) {
    padding: 8px 16px;
    font-size: 0.91rem;
    margin: 0;
  }

  ::slotted(p.version) {
    font-size: 0.78rem;
    margin-top: 16px;
  }

  ::slotted(p) {
    color: var(--ripe-app-primary-20);
    font-weight: 150;
  }

  #hover-body.light-theme {
    background-color: var(--ripe-app-primary-20);
    ::slotted(p),
    ::slotted(h4) {
      color: var(--ripe-app-primary-100, black);
    }

    ::slotted(a) {
      color: var(--ripe-app-secondary-100, green);
      text-decoration: none;
    }
  }
  ::slotted(h4) {
    font-size: 1rem;
    font-weight: 600;
    padding-top: 16px;
    color: var(--ripe-app-primary-20);
  }

  ::slotted(a) {
    margin-left: 16px;
    font-size: 0.91rem;
    text-decoration: underline;
    font-weight: 100;
    cursor: pointer;
  }

  ::slotted(button) {
    background-color: var(--ripe-app-primary-100);
    color: var(--ripe-app-primary-20);
    padding: 9px 16px;
    font-size: 0.91rem;
    margin-left: 16px;
    // text-transform: uppercase;
    cursor: pointer;
    background: none;
    border: none;
  }

  ::slotted(button:hover) {
    background-color: var(--ripe-app-primary-60);
  }

  #hover-body.light-theme:after {
    border-bottom-color: var(--ripe-app-primary-20);
  }
  #hover-body:after {
    position: absolute;
    // @media only screen and (max-width: 700px) {
    //   // make dropdown appear underneath center of user image
    //   right: 19px;
    // }

    top: -20px;
    right: 18px;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-bottom-color: var(--ripe-app-navbar-background, #080037);
    border-width: 10px;
    margin-left: -10px;
  }
</style>
